<template>
  <component
    :is="tag"
    class="focus-a:border-blue-600/75 focus-a:ring-4 focus-a:ring-blue-600/75"
    :class="{ 'border border-gray-300 dark:border-gray-800 shadow-sm rounded-lg p-4': border }"
  >
    <div class="flex flex-col h-full relative">
      <a
        :href="href"
        class="block grow hover:no-underline text-blue dark:text-white hover:text-blue dark:text-white ring-0"
      >
        <div class="text-base font-semibold ring-offset-2 pr-10 mb-2">
          {{ school.name }}
        </div>

        <div class="text-gray-500 font-normal text-xs sm:text-sm mb-2 flex gap-1 items-center whitespace-nowrap">
          <icon name="location" class="text-gray-300 dark:text-gray-500"/>
          {{ school.address }}
        </div>
      </a>

      <div class="flex flex-wrap items-center gap-y-1 gap-x-3 sm:gap-x-6">
        <inline-job-score-edit
          v-slot="{ activator }"
          v-model="user"
        >
          <l-button
            requires-auth
            class="flex gap-2 whitespace-nowrap items-center text-xs font-medium p-1 px-2 -mx-2"
            data-balloon-pos="up-left"
            :title="terms.jobScore"
            @click="activator"
          >
            <job-score :school="school" size="sm"/>
            <span class="mt-px">Job Score</span>
          </l-button>
        </inline-job-score-edit>

        <inline-admission-chances-edit
          v-slot="{ activator }"
          v-model="user"
        >
          <admission-chances
            class="text-xs font-medium p-1 px-2 -mx-2"
            data-balloon-pos="up-right"
            requires-auth
            :school="school"
            :part-time="partTime"
            :title="partTime ? terms.admissionChancesPt : terms.admissionChances"
            @click="activator"
          />
        </inline-admission-chances-edit>
      </div>

      <div class="absolute top-0 right-0 text-xl sm:text-2xl z-0">
        <add-school-button
          v-model="school"
          class="!p-2 -m-3"
        />
      </div>
    </div>
  </component>
</template>

<script setup>
import AddSchoolButton from "@/components/buttons/AddSchoolButton.vue"
import AdmissionChances from "@/components/AdmissionChances.vue"
import Icon from "@/components/Icon.vue"
import InlineAdmissionChancesEdit from "@/components/inlines/InlineAdmissionChancesEdit.vue"
import InlineJobScoreEdit from "@/components/inlines/InlineJobScoreEdit.vue"
import JobScore from "@/components/JobScore.vue"
import LButton from "@/components/buttons/LButton.vue"
import route from "ziggy-js"
import terms from "@/terms"
import { computed } from "vue"
import { useAuth } from "@/composables/useAuth"

const school = defineModel("school", { type: Object, required: true })

defineProps({
  partTime: { type: Boolean },
  tag: { type: String, default: "div" },
  border: { type: Boolean },
})

const { user } = useAuth()

const href = computed(() => route("schools.show", school.value))
</script>
